import React from "react";
import { FormattedMessage } from "react-intl";
import { useDispatch } from "react-redux";

import { Icon, ModalService } from "@sportal/cdk";

import { MobileModalListItem } from "../../../../../settings/tabs/devicesTab/tableComponents";
import { ScheduleRuleDialog } from "../../scheduleRuleDialog/ScheduleRuleDialog";
import { PlainButton } from "../../../../../../components/plainButton/PlainButton";
import { changeScheduleRule } from "../../../../../../store/schedules";

const useEditSchedule = (schedule, context) => {
  const dispatch = useDispatch();
  const { profileId, weekdays, timeFormat24h, type } = context;

  const edit = () => {
    ModalService.show((modal) => ({
      dialog: (
        <ScheduleRuleDialog
          modal={modal}
          profileId={profileId}
          weekdays={weekdays}
          timeFormat24h={timeFormat24h}
          scheduleType={type}
          schedule={schedule}
        />
      ),
    }))
      .then((schedule) => dispatch(changeScheduleRule(schedule)))
      .catch(() => {});
  };

  return {
    content: <FormattedMessage id="edit" />,
    icon: "fa-regular fa-pencil",
    action: edit,
    id: "edit-schedule",
  };
};
export const EditScheduleModalItem = ({ schedule, context }) => {
  const { content, action, id, icon } = useEditSchedule(schedule, context);

  return (
    <MobileModalListItem
      content={content}
      action={action}
      id={id}
      icon={icon}
    />
  );
};

export const EditScheduleButton = ({ schedule, className, context }) => {
  const { content, action, id, icon } = useEditSchedule(schedule, context);

  return (
    <PlainButton className={className} onClick={action} id={id}>
      <Icon icon={icon} />
      {content}
    </PlainButton>
  );
};
